import { useMemo } from 'react';

import { isHTTPError, isNetworkError } from '../../common/utils';
import { type ExtraErrorAttributes } from '../../common/utils/types';
import { useGlobalContextActions } from '../index';

export function shouldReportError(error: unknown): boolean {
	if (!isNetworkError(error)) {
		return true;
	}

	return !isHTTPError(error);
}

export type ReportError = (id: string, error: unknown, attributes?: ExtraErrorAttributes) => void;

export const useReportError = (): ReportError => {
	const { reporterAction } = useGlobalContextActions();

	return useMemo(
		() => (id: string, error: unknown, attributes?: ExtraErrorAttributes) => {
			if (!shouldReportError(error)) {
				return;
			}

			reporterAction({ id, error, attributes });
		},
		[reporterAction],
	);
};
